//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PcHeader from "@/pccomponents/Header"

export default {
  name: "layoutBlank",
  components: {
    PcHeader
  },
  data() {
    return {
        mainContentObj: {},
        showmenu:true,
        mainContentObj_scrollH: 0, // 记录上一次 mainContent 的内容高度
    }
  },
  computed: {
    loadingState() {
        return this.$store.state.loadingState;
    },
  },
  created(){
     //门户过来则隐藏菜单信息
     let headerflag = this.$route.query.headerflag;
     
     if(headerflag == 'header'){

        this.showmenu = false;
      }

      window.addEventListener('setItem',()=>{
         let aa = window.sessionStorage.getItem('loginedStatus');
         console.log("aaaaaaaaaaa"+aa);
         this.tipSuccess(aa);
      });
  },
  mounted(){
    //测试——判断前端登录状态标识
    console.log("loginstatus"+window.sessionStorage.getItem('loginedStatus'));
    // if(window.sessionStorage.getItem('loginedStatus') === null){
    //   this.$router.replace({ path: '/login'})
    // }

    // this.mainContentObj = this.$children[0].$children[1].$children[0].$refs.mainContent || {};
    // if (JSON.stringify(this.mainContentObj) !== "{}" && typeof this.mainContentObj === "object") { 
    //     this.setMainContentHeight(this.mainContentObj);
    //     window.onresize = () => {
    //         this.setMainContentHeight(this.mainContentObj);
    //     }

    //     this.mainContentObj_scrollH = this.mainContentObj.scrollHeight;
    // }
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/layout/LayoutBlank.vue